import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import './styles.css'

import { ThemeProvider } from '@mui/material'

import App from './App'
import { theme } from './theme'

const container = document.getElementById('root')
if (!container) {
  throw new Error(
    'Root container not found. Make sure there is a <div id="root"></div> in your index.html.'
  )
}

const root = createRoot(container)
const queryClient = new QueryClient()
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
)
